<template>
  <div class="returnorder">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="待审核" name="1">
                <div class="search">
                    <el-input v-model="shopid" placeholder="退货单ID"></el-input>
                    <el-input v-model="devicename" placeholder="设备名称"></el-input>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                    :data="tableData"
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    style="width: 100%">
                    <el-table-column
                        prop="id"
                        label="退货单ID"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceId"
                        label="设备ID"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceName"
                        width="180"
                        label="设备名称">
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        width="380"
                        label="退货数量">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        width="180"
                        label="审核状态">
                        <template slot-scope="scope">
                            {{scope.row.status ==1?'待审核':scope.row.status == 2?'审核通过':scope.row.status == 3?'审核未通过':''}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        width="180"
                        label="提交日期">
                    </el-table-column>
                    <el-table-column
                        label="操作">
                        <template slot-scope="scope">
                             <el-link :underline="false" @click="details(scope.row)">详情</el-link>
                        </template>
                    </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="审核通过" name="2">
                <div class="search">
                    <el-input v-model="shopid" placeholder="退货单ID"></el-input>
                    <el-input v-model="devicename" placeholder="设备名称"></el-input>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                    :data="tableData"
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    style="width: 100%">
                    <el-table-column
                        prop="id"
                        label="退货单ID"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceId"
                        label="设备ID"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceName"
                        width="180"
                        label="设备名称">
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        width="380"
                        label="退货数量">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        width="180"
                        label="审核状态">
                        <template slot-scope="scope">
                            {{scope.row.status ==1?'待审核':scope.row.status == 2?'审核通过':scope.row.status == 3?'审核未通过':''}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        width="180"
                        label="提交日期">
                    </el-table-column>
                    <el-table-column
                        label="操作">
                        <template slot-scope="scope">
                             <el-link :underline="false" @click="details(scope.row)">详情</el-link>
                        </template>
                    </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="审核未通过" name="3">
                <div class="search">
                    <el-input v-model="shopid" placeholder="退货单ID"></el-input>
                    <el-input v-model="devicename" placeholder="设备名称"></el-input>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                    :data="tableData"
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    style="width: 100%">
                    <el-table-column
                        prop="id"
                        label="退货单ID"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceId"
                        label="设备ID"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceName"
                        width="180"
                        label="设备名称">
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        width="380"
                        label="退货数量">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        width="180"
                        label="审核状态">
                        <template slot-scope="scope">
                            {{scope.row.status ==1?'待审核':scope.row.status == 2?'审核通过':scope.row.status == 3?'审核未通过':''}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        width="180"
                        label="提交日期">
                    </el-table-column>
                    <el-table-column
                        label="操作">
                        <template slot-scope="scope">
                             <el-link :underline="false" @click="details(scope.row)">详情</el-link>
                        </template>
                    </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
      </el-tabs>
      <div class="page">
          <el-pagination
            :background="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
      </div>
  </div>
</template>

<script>
import {backOrderList} from '../axios/api'
export default {
    data(){
        return{
            activeName: '1',
            shopid:'',
            devicename:'',
            tableData:[
                {
                    name:'jiji'
                }
            ],
            page:1,
            total:0,
            tabid:'1',
            state:0
        }
    },
    created(){
        this.getdata()
    },
    methods:{
        handleClick(tab, event) {
            console.log(tab, event);
            this.tabid = tab.name
            this.shopid = ''
            this.devicename = ''
            this.tableData = []
            this.getdata()
        },
        details(row){
            console.log(row)
            this.$router.push({
                name:'退货单详情',
                params:{
                    id:row.id
                }
            })
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.state == 0){
                this.getdata()
            }else{
                this.search1()
            }
        },
        async getdata(){
            this.state = 0
            var {data:dt} = await backOrderList({
                current:this.page,
                limit:10,
                shopId:window.localStorage.getItem('shopId'),
                status:this.tabid
            })    
            console.log(dt)
            if(dt.code == 200){
                this.tableData = dt.data.page.records
                this.total = dt.data.page.total
            }
        },
        async search(){
            this.state = 1
            var{data:dt} = await backOrderList({
                current:1,
                limit:10,
                shopId:window.localStorage.getItem('shopId'),
                status:this.tabid,
                deviceName:this.devicename,
                id:this.shopid
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                this.tableData = dt.data.page.records
                this.total = dt.data.page.total
            }
        },
        async search1(){
            this.state = 1
            var{data:dt} = await backOrderList({
                current:this.page,
                limit:10,
                shopId:window.localStorage.getItem('shopId'),
                status:this.tabid,
                deviceName:this.devicename,
                id:this.shopid
            })
            console.log(dt)
            if(dt.code == 200){
                this.tableData = dt.data.page.records
                this.total = dt.data.page.total
            }
        }
    }
}

</script>
<style lang="less" scope>
.returnorder{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link .el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    }
}
</style>